var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgUnsplashIcon = function SvgUnsplashIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = React.createElement("path", {
    fill: "currentColor",
    d: "M7.5 6.75V0h9v6.75zm9 3.75H24V24H0V10.5h7.5v6.75h9zm0 0"
  })));
};
export default __webpack_public_path__ + "cbd6e202096249364a41a47b9f2ac4d7.svg";
export { SvgUnsplashIcon as ReactComponent };